import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {EditUserType} from '../../../../../../service/user-management/user-management-edit-user';

type RoleFieldLangKeysType = {
    hint: LangKeyType | null;
    placeholder: LangKeyType;
};

// An SSO user's role comes from the SSO role mapping, so the role field only explains that.
export function getRoleFieldLangKeys(user: EditUserType | undefined, isSsoInvitation: boolean): RoleFieldLangKeysType {
    if (user?.isSso) {
        return {hint: 'USERS__FORM__SELECT_ROLE__SSO_HINT', placeholder: 'USERS__FORM__SELECT_ROLE__PLACEHOLDER'};
    }

    if (isSsoInvitation) {
        return {hint: 'USERS__FORM__AUTH_TYPE__SSO_HINT', placeholder: 'USERS__FORM__SELECT_ROLE__SSO_MAPPING'};
    }

    return {hint: null, placeholder: 'USERS__FORM__SELECT_ROLE__PLACEHOLDER'};
}
